import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { getLessonsPaginationData, LessonsPaginationDataArgs } from '../../../utils/client/lessons-pagination';

import { FullCourse } from '../../../typings';

// eslint-disable-next-line max-params
export function getCourse(
    courseId: number,
    withStudents: boolean | undefined,
    expandCLessons: boolean,
    order: string | undefined,
    paginationParams: LessonsPaginationDataArgs = {}
): Promise<FullCourse> {
    const { apiGetCourse } = apiConfig.getStaticUrls();

    const pagination = getLessonsPaginationData(paginationParams);

    return getFetch(`${apiGetCourse}${courseId}/`, {
        with_students: withStudents,
        expand_clessons: expandCLessons,
        // TODO: временное решение, связанное с особенностями рефакторинга бэка
        // сейчас дополнительные данные в поле lesson урока (name, date_updated, problems_count)
        // показываются по флагу expand_lessons. В будущем поля name и date_updated будут показываться всегда
        // а поле problems_count - по флагу with_problems_count
        expand_lessons: expandCLessons,
        order,
        ...pagination,
    });
}

/**
 * Подгружаем lessons не все сразу, а постранично и соединяем в один массив.
 * Чтобы не попадать на backend timeout https://st.yandex-team.ru/EDUCATION-13449
 */
// eslint-disable-next-line max-params
export async function getCoursePaginated(
    courseId: number,
    withStudents: boolean | undefined,
    expandCLessons: boolean,
    order?: string,
    paginationParams = { pageSize: 50 }
) {
    let page = 1;

    const getPage = () => getCourse(
        courseId, withStudents, expandCLessons, order, { ...paginationParams, page }
    );

    let response = await getPage();
    const result = response;

    while (response.lessons.length > 0) {
        page += 1;
        response = await getPage();
        result.lessons.push(...response.lessons);
    }

    return result;
}
